import React from 'react';
import Type from 'prop-types';
import { useParams } from 'react-router-dom';
import { TabPanel } from 'components';
import InvoicesScreen from '../../../InvoicesScreen';
import HistoryScreen from '../../../HistoryScreen';
import PaymentsScreen from '../../../PaymentsScreen';
import PledgesScreen from '../../../PledgesScreen';
import TaskListScreen from '../../../TaskListScreen';
import ChatScreen from '../../../ChatScreen';
import FilesScreen from '../../../FilesScreen';
import styles from './CascadePanels.module.css';

const panels = [
  HistoryScreen,
  InvoicesScreen,
  PaymentsScreen,
  FilesScreen,
  PledgesScreen,
  TaskListScreen,
  ChatScreen,
];

const CascadePanels = (props) => {
  const { tabs, listHeight } = props;
  const { tabId: activeTab } = useParams();

  return (
    <>
      {tabs.map((tab, idx) => {
        const { value } = tabs[idx];
        const PanelComponent = panels[idx];

        return (
          <TabPanel
            key={tab.value}
            value={activeTab}
            active={value}
            index={idx}
            className={styles.panel}
          >
            <PanelComponent listHeight={listHeight} />
          </TabPanel>
        );
      })}
    </>
  );
};

CascadePanels.propTypes = {
  listHeight: Type.number.isRequired,
  tabs: Type.arrayOf(
    Type.shape({
      label: Type.string.isRequired,
      value: Type.string.isRequired,
    }),
  ).isRequired,
};

export default CascadePanels;
